import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../components/Buttons";

export const Return = () => {
    document.title = "Qaytarma";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Satışlar", value: "/demands" },
        { name: "Qaytarma", value: "/demands/return", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Qaytarma</h2>
                    <p>
                        Satışların geri qaytarması sənədi, topdan satılan məhsulların geri qaytarılması üçün nəzərdə tutulub. Nümunədə sənədin yaradılması
                        ardıcıllığı göstərilib. Yeni yaradılmış satışın qaytarılması sənədini ardıcıllıqla doldurub <SaveButton /> düyməsini sıxın.
                    </p>
                    <img src="/images/demands/return-1.gif" alt="Qaytarma" />
                    <p>
                        Satışın qaytarılması sənədini qısa yolla da yaratmaq olar. Bunun üçün satış sənədini tərk etmədən <Button>Sənəd yarat</Button>
                        düyməsini, daha sonra isə qaytarılan məhsulları sənəddə saxlayıb <Button>Qaytarma</Button> düyməsini sıxmaq lazımdır. Sənədi yadda
                        saxlamaq üçün <SaveButton /> düyməsini sıxmaq lazım olacaq
                    </p>
                    <img src="/images/demands/return-2.gif" alt="Qaytarma" />
                </article>
            </div>
        </div>
    );
};
